import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

export default class extends Controller {
  static values = { refreshUrl: String }

  refresh() {
    if (!this.hasRefreshUrlValue) return

    const params = new URLSearchParams()
    const formData = new FormData(this.element)

    for (const [key, value] of formData.entries()) {
      // File inputs cannot be round-tripped through a query string.
      if (value instanceof File) continue
      if (key === "authenticity_token" || key === "_method" || key === "commit") continue
      params.append(key, value)
    }

    const url = `${this.refreshUrlValue}?${params.toString()}`
    Turbo.visit(url, { action: "replace" })
  }
}
